import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as firebase from "firebase";



@Injectable()
export class EventLoggerProvider {

  constructor(public http: HttpClient) { }

  logButton(name: string, value: any) {
    firebase.analytics().logEvent(name, { pram: value })
  }

  logPageView(pageName: string) {
    let name: string = 'page_view';
    firebase.analytics().logEvent(name, { pram: pageName })
  }
}



// WEBPACK FOOTER //
// ./src/providers/event-logger/event-logger.ts